import { css } from 'lit';

import { typography, px } from '../../styles';
import color from '../../utils/get-color-token';
import token from '../../utils/get-token';

function styles() {
	return [
		css`
			:host {
				--m-field-hint-color: ${color('color-text-tertiary')};
			}

			m-group {
				${px(token('spacing-2'))};
			}

			.-status-danger {
				--m-field-hint-color: ${color('color-danger-60')};
			}

			.hint {
				${typography('body-sm')};
				color: var(--m-field-hint-color);
			}
		`,
	];
}

export default styles;
